import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Check, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { ROLE_INFO } from "@/context/AuthContext";
import { Badge, Button, Card, ErrorState, Loading, Page, PageHeader } from "@/components/kit";

export default function Users() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const { data = [], isLoading, isError, error, refetch } = useQuery({ queryKey: ["users"], queryFn: () => api("/users") });
  const done = (m) => { qc.invalidateQueries({ queryKey: ["users"] }); toast.success(m); };
  const approve = useMutation({ mutationFn: (id) => api(`/users/${id}/approve`, { method: "POST" }), onSuccess: () => done("Cadastro aprovado"), onError: (e) => toast.error(e.message) });
  const reject = useMutation({ mutationFn: (id) => api(`/users/${id}`, { method: "DELETE" }), onSuccess: () => done("Cadastro recusado"), onError: (e) => toast.error(e.message) });
  const pending = data.filter((u) => !u.approved);
  const active = data.filter((u) => u.approved);
  return (
    <Page narrow>
      <PageHeader title="Usuários" back right={<Button icon={UserPlus} onClick={() => nav("/users/new")} data-testid="new-user-button"><span className="hidden sm:inline">Novo usuário</span></Button>} />
      {isLoading ? <Loading /> : isError ? <ErrorState message={error.message} onRetry={refetch} /> : (
        <>
          {pending.length > 0 && (
            <div className="flex flex-col gap-3 mb-6" data-testid="pending-users-section">
              <div className="h3">Aguardando aprovação ({pending.length})</div>
              {pending.map((u) => (
                <Card key={u.id} data-testid={`pending-user-${u.id}`}>
                  <div className="label">{u.name}</div>
                  <div className="caption">{u.email} · entrará como Operador</div>
                  <div className="flex gap-2 mt-3">
                    <Button variant="secondary" size="sm" loading={reject.isPending} onClick={() => reject.mutate(u.id)} data-testid={`reject-user-${u.id}`}>Recusar</Button>
                    <Button size="sm" icon={Check} loading={approve.isPending} onClick={() => approve.mutate(u.id)} data-testid={`approve-user-${u.id}`}>Aprovar</Button>
                  </div>
                </Card>
              ))}
            </div>
          )}
          <div className="h3 mb-3">Usuários ativos</div>
          <div className="card divide" style={{ padding: 0 }} data-testid="users-list">
            {active.map((u) => (
              <div key={u.id} className="row-link" onClick={() => nav(`/users/${u.id}`)} data-testid={`user-row-${u.id}`}>
                <div className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-white" style={{ background: "var(--brand)" }}>{u.name[0]}</div>
                <div className="flex-1 min-w-0"><div className="h3 truncate">{u.name}</div><div className="caption truncate">{u.email}</div></div>
                {!u.active && <Badge tone="muted">Inativo</Badge>}
                <Badge>{ROLE_INFO[u.role]?.label}</Badge>
              </div>
            ))}
          </div>
        </>
      )}
    </Page>
  );
}
